import { toggle } from '@/features/sidebar';
import { IconButton } from '@/layouts/authenticated/components/top-navigation/components/icon-button';

const SIDEBAR_ID = 'help-dropdown';

type HelpButtonProps = {
  showLabel: boolean;
  /** Called after the button toggles the help sidebar. */
  onClick?: () => void;
};

export function HelpButton({ showLabel, onClick }: HelpButtonProps) {
  const handleClick = () => {
    toggle(SIDEBAR_ID);
    onClick?.();
  };

  return <IconButton onClick={handleClick} icon="help" size="md" label="Need help?" showLabel={showLabel} />;
}
